export default __webpack_public_path__ + "static/media/(74).65cea60a.jpg";